import React,{useState,useEffect} from "react"
import { useTranslation } from "react-i18next";

//MUI
import CloudOutlinedIcon from "@mui/icons-material/CloudOutlined";
import {Box, Typography,CircularProgress} from "@mui/material"

// Custom
import InfoPaneActionButton from "./InfoPaneActionButton";
import { Coordinate } from "ol/coordinate";

import api from "@/lib/api";

type InfoPaneWeatherActionButtonProps = {
  handleFetchWeatherData: () => void;
}

const InfoPaneWeatherActionButton = (props: InfoPaneWeatherActionButtonProps) => {

    const { t } = useTranslation();

    const { handleFetchWeatherData } = props;
   
    return (       
          <InfoPaneActionButton
            title_ttoken={"buttons.forecast"}
            icon={<CloudOutlinedIcon sx={{transform: "scale(0.8)"}} color="primary" fontSize="large"/>}
            onClick={(evt)=>{handleFetchWeatherData()}}
          /> 
    );

}

export default InfoPaneWeatherActionButton;

